import * as React from 'react';
import {View} from 'react-native';
import {upperFirst} from 'lodash';

import InlineFormattedNumber from '/component/base/FormattedNumber/InlineFormattedNumber';
import ListItem from '/component/base/ListItem';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {UserProfileModal} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';
import {getDateUtilDefaultInstance} from '/util/date.util';

import {styles} from './ExpiringRewardsReportContent.style';

interface RewardHistoryItem {
  eventType: string;
  date: string;
  value: number;
}

interface Props {
  tt: (key: string, defaultValue?: string) => string;
  recordData: {
    rewards: {
      balance: number;
      currencyCode: string;
      history: RewardHistoryItem[];
    };
  };
}

export const ExpiringRewardsReportContent: React.FC<Props> = ({
  tt,
  recordData,
}) => {
  const {
    rewards: {balance, currencyCode, history},
  } = recordData;

  return (
    <View style={styles.base}>
      <View style={styles.header}>
        <Gutter>
          <Text emphasis="low" style={styles.heading} variant="subheading">
            {tt('title', 'Current Reward Balance')}
          </Text>
          <InlineFormattedNumber
            testID={UserProfileModal.rewardsBalance}
            textVariant="xLarge"
            style={styles.date}
            value={balance}
            decimalPlaces={2}
            currencyCode={currencyCode}
          />
        </Gutter>
        <Gutter>
          <Text variant="heading" style={styles.subheading}>
            {tt('subtitle', 'History')}
          </Text>
        </Gutter>
      </View>

      {history.map(({eventType, date, value}) => (
        <Gutter key={`${date}-${eventType}`}>
          <ListItem
            style={{base: styles.listItem}}
            readonly={true}
            label={
              <View>
                <Text
                  style={styles.listItemDate}
                  testID={UserProfileModal.rewardsHistoryDate}>
                  {getDateUtilDefaultInstance().formatDate(
                    date,
                    'MMMM d, yyyy',
                  )}
                </Text>
                <Text
                  emphasis="low"
                  variant="caption"
                  testID={UserProfileModal.rewardsHistoryStatus}>
                  {upperFirst(eventType)}
                </Text>
              </View>
            }
            suffix={
              <InlineFormattedNumber
                testID={UserProfileModal.rewardsHistoryBalance}
                style={(styles as any)[eventType]} // TS fallback if styles are dynamic
                value={value}
                decimalPlaces={2}
                currencyCode={currencyCode}
              />
            }
          />
        </Gutter>
      ))}
    </View>
  );
};

export default withTranslation('reportCardContent.expiringRewardsClients')(
  ExpiringRewardsReportContent,
);
